"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tag = exports.TagColor = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const web_sds_c_1 = require("@snapchat/web-sds-c");
const clsx_1 = __importDefault(require("clsx"));
const Tag_module_css_1 = __importDefault(require("./Tag.module.css"));
var TagColor;
(function (TagColor) {
    TagColor[TagColor["YELLOW"] = 0] = "YELLOW";
})(TagColor = exports.TagColor || (exports.TagColor = {}));
function getTagClassName(tagColor) {
    switch (tagColor) {
        case TagColor.YELLOW:
            return Tag_module_css_1.default.yellowTagContainer;
        default:
            return Tag_module_css_1.default.tagContainer;
    }
}
function getSelectedTagClassName(tagColor) {
    switch (tagColor) {
        case TagColor.YELLOW:
            return "";
        default:
            return Tag_module_css_1.default.tagContainerSelected;
    }
}
function getNotSelectedTagClassName(tagColor) {
    switch (tagColor) {
        case TagColor.YELLOW:
            return "";
        default:
            return Tag_module_css_1.default.tagContainerNotSelected;
    }
}
/**
 * Tag / Pill component used to filter things out
 */
function Tag({ isSelected, text, onSelect, tagColor }) {
    return ((0, jsx_runtime_1.jsx)("button", { type: "button", className: (0, clsx_1.default)(getTagClassName(tagColor), {
            [getSelectedTagClassName(tagColor)]: isSelected,
            [getNotSelectedTagClassName(tagColor)]: !isSelected,
        }), onClick: onSelect, children: (0, jsx_runtime_1.jsx)("div", { className: (0, clsx_1.default)(Tag_module_css_1.default.tagContainerInner, {
                [getSelectedTagClassName(tagColor)]: isSelected,
                [Tag_module_css_1.default.tagInvisibleBorder]: !isSelected,
            }), children: (0, jsx_runtime_1.jsx)("span", { className: (0, web_sds_c_1.getClassName)("H4", false), "data-testid": "tag_text", children: (0, jsx_runtime_1.jsx)("span", { className: Tag_module_css_1.default.tagText, children: text }) }) }) }));
}
exports.Tag = Tag;
//# sourceMappingURL=Tag.js.map